import React from 'react';
import { connect } from 'react-redux';
import { find } from 'lodash/fp';
import * as actions from 'actions/pathBuilder/contents';
import ModalContainer from 'components/shared/modal/modal_container';
import RenderInBody from 'components/shared/render_in_body';
import InfoTooltip from 'components/shared/InfoTooltip';
import Select from 'components/shared/select';
import Tooltip from 'components/shared/Tooltip';
import { Button, ButtonGroup, Icon } from 'ui';
import { routes, TYPES } from 'constants/config';
import request from 'utils/request_ajax';

const preventLineBreaks = e => {
  if (e.key === 'Enter') e.preventDefault();
};

const demonstrationTypes = [
  {
    id: 'url',
    title: t('demonstrations.types.url.title'),
    description: t('demonstrations.types.url.description'),
  },
];

class DemonstrationCreationModal extends React.Component {
  state = {
    title: '',
    description: '',
    demonstrationType: 'url',
    loading: false,
  };

  createDemonstration = () => {
    const { title, description, demonstrationType } = this.state;
    const { position, addDemonstration } = this.props;
    const attributes = {
      title,
      description,
      demonstrationType,
      position,
    };
    request
      .post(routes.DEMONSTRATION_INDEX, {
        demonstration: attributes,
      })
      .then(response => {
        addDemonstration(position, response.demonstration);
      })
      .catch(error => {
        console.error(error);
      });
  };

  handleInputChange = e => {
    const { name } = e.target;
    let { value } = e.target;
    if (name === 'description') {
      value = value.replace(/\r?\n|\r/g, ' ');
    }
    this.setState({ [name]: value });
  };

  handleSubmit = e => {
    e.preventDefault();
    this.createDemonstration();
    this.props.closeModal();
  };

  render() {
    const { title, description, demonstrationType, loading } = this.state;
    const { closeModal } = this.props;
    return (
      <RenderInBody type="portal">
        <ModalContainer
          className="ModalTakeover-background Modal-background d-f ai-c"
          onEscape={closeModal}
          manualAutoFocus
        >
          <div className="ModalTakeover-container LessonCreationModal">
            <div className="LessonCreationModal-body">
              <form onSubmit={this.handleSubmit}>
                <div className="LessonCreationModal-title">
                  {t('demonstrations.create_modal.new_demonstration')}
                  <InfoTooltip
                    tooltip={t('demonstrations.create_modal.more_info')}
                    className="ml-8"
                  />
                </div>
                <div className="LessonCreationModal-subtitle">
                  {t('demonstrations.create_modal.instructions')}
                </div>
                <label
                  htmlFor="title"
                  className="LessonCreationModal-inputTitle"
                >
                  {t('common.title')}*
                </label>
                {/* eslint-disable jsx-a11y/no-autofocus */}
                <input
                  id="title"
                  name="title"
                  className="NewInput NewInput--white NewInput--fw ModalTakeover-nameInput"
                  placeholder={t('common.enter_title')}
                  type="text"
                  onChange={this.handleInputChange}
                  value={title}
                  maxLength="255"
                  required
                  autoFocus
                />
                {/* eslint-enable jsx-a11y/no-autofocus */}
                <label
                  htmlFor="description"
                  className="LessonCreationModal-inputTitle"
                >
                  {t('common.description')}
                </label>
                <textarea
                  id="description"
                  name="description"
                  className="NewInput NewInput--white NewInput--fw"
                  placeholder={t('common.enter_description')}
                  rows="3"
                  onChange={this.handleInputChange}
                  onKeyDown={preventLineBreaks}
                  value={description}
                />
                <label
                  htmlFor="demonstration_type"
                  className="LessonCreationModal-inputTitle"
                >
                  {t('demonstrations.create_modal.type')}*
                </label>
                <Select
                  name="demonstration_type"
                  id="demonstration_type"
                  onChange={this.handleInputChange}
                  fullWidth
                >
                  {demonstrationTypes.map(typeData => (
                    <option key={typeData.id} value={typeData.id}>
                      {typeData.title}
                    </option>
                  ))}
                </Select>
                <p className="mt-8">
                  {
                    find({ id: demonstrationType }, demonstrationTypes)
                      .description
                  }
                </p>
                <Tooltip
                  text={
                    !title && t('demonstrations.create_modal.disabled_submit')
                  }
                  align="end"
                >
                  <ButtonGroup alignEnd className="mt-32">
                    <Button
                      primary
                      type="submit"
                      loading={loading}
                      disabled={!title}
                    >
                      {t('demonstrations.create_modal.create_demonstration')}
                    </Button>
                  </ButtonGroup>
                </Tooltip>
              </form>

              <button
                type="button"
                className="u-resetBtn ModalTakeover-closeButton"
                onClick={closeModal}
              >
                <Icon name="error" />
              </button>
            </div>
          </div>
        </ModalContainer>
      </RenderInBody>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  addDemonstration: (position, demonstration) =>
    dispatch(actions.add(TYPES.DEMONSTRATION, position, demonstration)),
});

export default connect(null, mapDispatchToProps)(DemonstrationCreationModal);
